"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pronunciationIntelligibility = pronunciationIntelligibility;
exports.worstPronunciationWords = worstPronunciationWords;
exports.pronunciationPracticeWords = pronunciationPracticeWords;
const pronunciationFeedback_1 = require("./pronunciationFeedback");
/** Prefer the stored algorithm result; older records retain their original exact-word score. */
function pronunciationIntelligibility(result) {
    const check = result.wordCheck;
    if (check?.status !== "verified")
        return null;
    return (check.understoodPercent ??
        (check.referenceWords
            ? (100 * check.matchedWords) / check.referenceWords
            : 0));
}
function worstPronunciationWords(result, settings) {
    const rank = (word) => {
        const feedback = (0, pronunciationFeedback_1.getPronunciationFeedback)(word, settings);
        if (feedback === "missing" || feedback === "different")
            return 0;
        if (feedback === "uncertain")
            return 1;
        return 2;
    };
    return result.words
        .filter((word) => word.errorType !== "Insertion" &&
        !["matched", "ignored"].includes((0, pronunciationFeedback_1.getPronunciationFeedback)(word, settings)))
        .sort((left, right) => rank(left) - rank(right) ||
        (left.verification?.similarity ?? left.accuracy / 100) -
            (right.verification?.similarity ?? right.accuracy / 100))
        .filter((word, index, words) => words.findIndex((other) => other.word.toLocaleLowerCase() === word.word.toLocaleLowerCase()) === index)
        .slice(0, 5);
}
/** Recommendations are actionable recognition errors, gated by the intelligibility verdict. */
function pronunciationPracticeWords(result, settings) {
    const understood = pronunciationIntelligibility(result);
    if (understood === null || understood >= (settings.goodIntelligibility ?? 88))
        return [];
    return worstPronunciationWords(result, settings).filter((word) => {
        const feedback = (0, pronunciationFeedback_1.getPronunciationFeedback)(word, settings);
        return feedback === "different" || feedback === "missing";
    });
}
//# sourceMappingURL=pronunciationSummary.js.map